import { Fragment, useEffect, useRef, version } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import MicrosoftLogin from "react-microsoft-login";
import ReactDOM from "react-dom";
import { useState } from "react";
import { useCookies } from "react-cookie";
import ExcelTableSearch from "./ExcelTableSearch";
import SETTINGS from "./../settings.json";
import "./Dashboard.css";
import { getUserInfo, postSearchActivity, postVisitActivityV2 } from "./api";
import { getPic } from "./script";
import $ from "jquery";
import "select2";
// import GetMyPic from "./GetMyPic";
const user = {
  imageUrl:
    "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Dashboard(logoutHandler) {
  let microsoftAccount = {};
  let email;
  let handle;
  const [caseBool,setCaseBool]=useState(false)
  const [cookies, setCookies, removeCookies] = useCookies([
    "name",
    "email",
    "authority",
    "accessToken",
    "emailAddress",
  ]);
  const [type, setType] = useState([]);
  const [ver, setVer] = useState([]);
  const [msalInstance, setMsalInstance] = useState(() => {
    if (cookies.email && !localStorage.search)
      postVisitActivityV2(cookies.emailAddress, "Granted");
    return cookies.email;
  });
  let verSet = new Set();
  const [search, setSearch] = useState("");
  const userNavigation = [{ name: "Sign out", href: "#" }];
  const selectRef = useRef(null);
  const [rend, setRend] = useState(true);
  let run = async () => {
    if (rend) {
      const response2 = await fetch("./output_fil.json");
      const jsonData = await response2.json();
      for (let it of jsonData) {
        verSet.add(it.Vertical);
      }
      let ch = Array.from(verSet)
        .sort()
        .map((it) => <option value={it}>{it ? it : "Unlisted"}</option>);
      ch.unshift(<option>All Verticals</option>);
      const root = ReactDOM.createRoot(document.getElementById("selectVer"));
      root.render(ch);
      $("#general").select2({
        placeholder: "Type of Search",
      });
      $("#general").on("select2:select select2:unselect", function (e) {
        const selectElement = document.getElementById("general");
        const selectedValues = [];

        for (let i = 0; i < selectElement.options.length; i++) {
          const option = selectElement.options[i];
          if (option.selected) {
            selectedValues.push(option.value);
          }
        }
        setType(selectedValues);
      });

      $("#selectVer").select2({
        placeholder: "Verticals to search",
      });
      $("#selectVer").on("select2:select select2:unselect", function (e) {
        const selectElement = document.getElementById("selectVer");
        const selectedValues = [];

        for (let i = 0; i < selectElement.options.length; i++) {
          const option = selectElement.options[i];
          if (option.selected) {
            selectedValues.push(option.value);
          }
        }
        setVer(selectedValues);
      });
      setRend(false);
      return () => {
        $("#general").select2("destroy");
        $("#selectVer").select2("destroy");
      };
    }
  };

  // useEffect(() => {
  //   run();
  // }, []);

  // console.log("reloaded")
  // window.addEventListener(
  //   "beforeunload",()=>{
  //     removeCookies("email","accessToken")
  //   }
  // )
  const authHandler = async (err, data, msal) => {
    if (err) {
      console.log(err);
    }
    if (data) {
      // console.log(msalInstance);
      console.log(data);
      // console.log(data);
      microsoftAccount = data;
      setCookies("name", data.account.name);
      setCookies("accessToken", data.accessToken);
      getUserInfo(data.accessToken);
      setCookies("authority", data.authority);
      setMsalInstance("msal", msal);
      setCookies("emailAddress", microsoftAccount.account.username);
      email = microsoftAccount.account.username;
      handle = email.split("@")[1].split(".")[0];
      setCookies("email", handle);
      setMsalInstance(handle);
      // console.log(data.accessToken)
      if (handle != "leadsquared") {
        // console.log("Your handle is good");
        const container = document.getElementById("root");
        const root = ReactDOM.createRoot(container);
        root.render(
          <b className="block absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center font-semibold">
            <b className="font-extrabold text-3xl">Access Denied</b>
            <br />
            Sorry <b className="font-bold">{cookies.name.split(" ")[0]} </b>!
            Your email: <b className="font-bold">{email}</b> is not valid.
            <br />
            <b className="font-bold underline">Note</b>: Please use leadsquared
            credentials to login.
          </b>
        );
      } else {
        if (msalInstance) {
          // console.log("Your handle is good");
          const container = document.getElementById("root");
          const root = ReactDOM.createRoot(container);
          root.render(<Dashboard />);
        }
      }
    }
  };
  function logoutHandler() {
    // console.log("called");
    removeCookies("email");
    removeCookies("accessToken");
    window.location.reload();
    // msalInstance.logout();
  }

  return (
    <div className="select-text caret-transparent">
      {msalInstance == "leadsquared" ? (
        <div className="overflow-auto">
          <>
            <div className="min-h-full">
              <Disclosure as="nav" className="bg-gray-800">
                {({ open }) => (
                  <>
                    <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-8">
                      <div className="hidden md:grid p-2 grid-cols-3 ">
                        <div className="col-span-1 flex items-center">
                          <div className="">
                            <img
                              className="h-fit w-40 bg-slate-50 p-2"
                              src="https://leadsquaredhrms.darwinbox.in/ms/s3proxy/getFile?fileKey=INSTANCE5_a628dc27a1815b_182/logo/a62fb478caf09a__tenant-avatar-182_1242004863.png"
                              alt="LeadSquared Logo"
                            />
                          </div>
                          <div className="">
                            <button
                              className="hover:scale-110 mt-2"
                              onClick={() => {
                                const container =
                                  document.getElementById("renderId");
                                const root = ReactDOM.createRoot(container);
                                root.render(<ExcelTableSearch search={""} />);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="white"
                                className="w-6 h-6 ml-4 active:fill-blue-400"
                              >
                                <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                                <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="col-span-1 text-center text-neutral-50 text-2xl font-thin">
                          Tools & Deal Finder
                        </div>
                        <div className="col-span-1 ">
                          <div className="ml-4 flex items-center md:ml-6 gap-2">
                            <div className="flex border border-gray-900 rounded-lg w-80">
                              <div className="relative ">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="none"
                                  onMouseDownCapture={() => {
                                    document.getElementById("filters")
                                      .className ==
                                    "ml-2 absolute bg-transparent z-50 w-80"
                                      ? (document.getElementById(
                                          "filters"
                                        ).className = "hidden")
                                      : (document.getElementById(
                                          "filters"
                                        ).className =
                                          "ml-2 absolute bg-transparent z-50 w-80");
                                  }}
                                  className="w-8 h-10 p-1 stroke-gray-500 hover:fill-zinc-600 cursor-pointer"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
                                  />
                                </svg>
                                <div
                                  id="filters"
                                  className=" absolute bg-transparent z-50 hidden"
                                >
                                  <div className="border border-b-8 border-b-zinc-300 border-x-8 w-0 border-x-transparent border-t-0 ml-1 pt-1"></div>
                                  <div className="bg-zinc-200 border-2 border-zinc-300 p-2 rounded-b-lg rounded-l-md rounded-r-lg">
                                    <div className="font-bold pb-2 text-center text-lg">
                                      Customize Search
                                    </div>
                                    <div className="grid grid-cols-1 gap-2 p-1">
                                      <select
                                        name=""
                                        id="general"
                                        className="outline-none h-8 rounded-md col-span-1 w-72"
                                        multiple
                                      >
                                        <option value="tool">
                                          Tool Name based
                                        </option>
                                        <option value="deal">
                                          Deal Name based
                                        </option>
                                      </select>

                                      <select
                                        ref={selectRef}
                                        className=" outline-none rounded-md col-span-1 w-72"
                                        name=""
                                        id="selectVer"
                                        onLoad={run()}
                                        multiple
                                      >
                                        <option value="">
                                          Choose Vertical
                                        </option>
                                      </select>
                                    </div>
                                    <button
                                      className="mx-[50%] -translate-x-[50%] mt-5 bg-slate-800 py-1 px-3  rounded-md text-white"
                                      onClick={() => {
                                        document.getElementById(
                                          "filters"
                                        ).className =
                                          "ml-2 absolute bg-transparent z-50 hidden";
                                        console.log(type, ver);
                                      }}
                                    >
                                      Done
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <input
                                type="text"
                                id="input-group-1"
                                className="bg-gray-700 border-l caret-white border-gray-900 text-sm  text-white block w-full pl-4 p-2.5 outline-none"
                                placeholder="Search Here !"
                                onKeyDown={async (event) => {
                                  if (event.key == "Enter") {
                                    await postSearchActivity(
                                      cookies.emailAddress,
                                      search
                                    );
                                    const container =
                                      document.getElementById("renderId");
                                    const root = ReactDOM.createRoot(container);
                                    root.render(
                                      <ExcelTableSearch
                                        search={search}
                                        type={type}
                                        ver={ver}
                                        case={caseBool}
                                      />
                                    );
                                  }
                                }}
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                              <button id='caseInsensitive' className="bg-gray-700 py-1 px-2 rounded-r-lg text-sm text-zinc-400 line-through" onClick={()=>{
                                console.log(!caseBool)
                                setCaseBool(!caseBool)
                                document.getElementById('caseInsensitive').className=="bg-gray-700 py-1 px-2 rounded-r-lg text-sm text-zinc-400 line-through"?
                              document.getElementById('caseInsensitive').className="bg-gray-700 py-1 px-2 rounded-r-lg text-sm underline text-zinc-400":
                              document.getElementById('caseInsensitive').className="bg-gray-700 py-1 px-2 rounded-r-lg text-sm text-zinc-400 line-through"
                              }}>Abc</button>
                            </div>
                            <button
                              type="button"
                              className="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 m-1 focus:ring-offset-gray-800"
                              onClick={async () => {
                                await postSearchActivity(
                                  cookies.emailAddress,
                                  search
                                );
                                const container =
                                  document.getElementById("renderId");
                                const root = ReactDOM.createRoot(container);
                                root.render(
                                  <ExcelTableSearch
                                    search={search}
                                    type={type}
                                    ver={ver}
                                    case={caseBool}
                                  />
                                );
                              }}
                            >
                              <MagnifyingGlassIcon
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </button>

                            {/* Profile dropdown */}
                            <Menu as="div" className="relative ml-3">
                              <div>
                                <Menu.Button className="flex max-w-xs items-center rounded-full border-2 border-white  bg-gray-800 text-sm focus:outline-none focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 hover:scale-110">
                                  <span className="sr-only">
                                    Open user menu
                                  </span>
                                  <img
                                    id="profilePicture"
                                    src="user.jpg"
                                    alt=""
                                    className="rounded-full w-10"
                                  />
                                  {cookies.accessToken
                                    ? getPic(cookies.accessToken)
                                    : ""}
                                </Menu.Button>
                              </div>
                              <Transition
                                as={Fragment}
                                enter="transition ease-out duration-100"
                                enterFrom="transform opacity-0 scale-95"
                                enterTo="transform opacity-100 scale-100"
                                leave="transition ease-in duration-75"
                                leaveFrom="transform opacity-100 scale-100"
                                leaveTo="transform opacity-0 scale-95"
                              >
                                <Menu.Items className=" absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-1 shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                                  <div className="absolute h-0 w-0 border border-x-4 border-x-transparent border-b-8 border-b-white -top-2 right-4 border-t-0"></div>
                                  <ul>
                                    <li className="text-center text-sm">
                                      Hey <b>{cookies.name.split(" ")[0]}</b> !
                                    </li>
                                  </ul>
                                  {userNavigation.map((item) => (
                                    <Menu.Item key={item.name}>
                                      {({ active }) => (
                                        <button
                                          onClick={logoutHandler}
                                          className={classNames(
                                            active ? "bg-gray-100" : "",
                                            "block px-4 py-2 text-sm text-gray-700 w-full text-left"
                                          )}
                                        >
                                          {item.name}
                                        </button>
                                      )}
                                    </Menu.Item>
                                  ))}
                                </Menu.Items>
                              </Transition>
                            </Menu>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-4 md:hidden">
                        <div className="col-span-1">
                          <img
                            className="pt-1 scale-75"
                            src="./minilsq.png"
                            alt="LeadSquared Logo"
                          />
                        </div>
                        <div className="col-span-2 pt-3 pb-2 text-center text-neutral-50 text-2xl font-thin">
                          Tools & Deal Finder
                        </div>
                        <div className="col-span-1 grid grid-cols-1 text-white">
                          <button
                            onClick={() => {
                              document.getElementById("dropmenu").className ==
                              "hidden"
                                ? (document.getElementById(
                                    "dropmenu"
                                  ).className =
                                    "grid grid-cols-4 md:hidden p-3")
                                : (document.getElementById(
                                    "dropmenu"
                                  ).className = "hidden");
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="white"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="m-5 w-9 h-9 col-span-2"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div id="dropmenu" className="hidden">
                        <div className="col-span-1">
                          <button
                            className="hover:scale-110 mt-2"
                            onClick={() => {
                              const container =
                                document.getElementById("renderId");
                              const root = ReactDOM.createRoot(container);
                              root.render(<ExcelTableSearch search={""} />);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="white"
                              className="w-6 h-6 ml-4 active:fill-blue-400"
                            >
                              <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                              <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                            </svg>
                          </button>
                        </div>
                        <div className="col-span-2 grid-cols-2">
                          <input
                            type="text"
                            id="input-group-1"
                            class="bg-gray-700 border caret-white border-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 text-white block w-full pl-4 p-2.5"
                            placeholder="Search Here !"
                            onKeyDown={async (event) => {
                              if (event.key == "Enter") {
                                await postSearchActivity(
                                  cookies.emailAddress,
                                  search
                                );
                                const container =
                                  document.getElementById("renderId");
                                const root = ReactDOM.createRoot(container);
                                root.render(
                                  <ExcelTableSearch search={search} />
                                );
                              }
                            }}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-span-1">
                          <button
                            type="button"
                            className="ml-6 rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 m-1 focus:ring-offset-gray-800"
                            onClick={async () => {
                              await postSearchActivity(
                                cookies.emailAddress,
                                search
                              );
                              const container =
                                document.getElementById("renderId");
                              const root = ReactDOM.createRoot(container);
                              root.render(<ExcelTableSearch search={search} />);
                            }}
                          >
                            <MagnifyingGlassIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </div>
                      <div className="scale-150 fixed z-10 right-5 bottom-5 md:hidden">
                        <Menu as="div" className="relative ml-3">
                          <div>
                            <Menu.Button className="flex max-w-xs p-1 items-center rounded-full border-2 border-white  bg-gray-800 text-sm focus:outline-none focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 hover:scale-110">
                              <span className="sr-only">Open user menu</span>

                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="white"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6 text-white"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                                />
                              </svg>
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 bottom-10 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                              {userNavigation.map((item) => (
                                <Menu.Item key={item.name}>
                                  {({ active }) => (
                                    <button
                                      onClick={logoutHandler}
                                      className={classNames(
                                        active ? "bg-gray-100" : "",
                                        "block px-4 py-2 text-sm text-gray-950 w-full text-left "
                                      )}
                                    >
                                      {item.name}
                                    </button>
                                  )}
                                </Menu.Item>
                              ))}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                      </div>
                    </div>
                  </>
                )}
              </Disclosure>
            </div>
          </>
          <div
            id="renderId"
            className="overflow-scroll md:overflow-hidden overflow-x-scroll overflow-y-auto"
          >
            <ExcelTableSearch className="z-10" search={""} />
          </div>
        </div>
      ) : (
        <div>
          <img src="./etoolbg.jpg" alt="" className="w-screen h-screen -z-50" />
          <img
            src="/lsqm.png"
            alt="Leadsquared Logo"
            className="absolute w-56 top-[23%] left-1/2 -translate-x-1/2 -translate-y-[23%] shadow-blue-50 rounded-md p-3  shadow-[0_0_1px_1px]"
          />
          <div className="z-10 bg-blue-300 bg-opacity-40 absolute top-2/3 left-1/2 -translate-x-1/2 -translate-y-2/3 border border-solid border-blue-300 shadow-blue-200 rounded-md shadow-[0_0_2px_2px] h-60 w-80 text-center">
            <div className=" flex flex-col justify-around">
              <div className="mt-10 text-lg font-semibold">
                Hello{" "}
                <c className="font-sans text-blue-600 animate-pulse">
                  {cookies.name}
                </c>{" "}
                !
              </div>
              <div className="mt-8 text-left m-auto text-lg text-slate-800 font-semibold">
                Login to continue
              </div>
              <MicrosoftLogin
                className=" absolute bottom-8 left-12 border border-slate-400 hover:scale-105 hover:border-blue-600 active:border-red-500"
                clientId={`${SETTINGS.clientId}`}
                redirectUri={window.location.href}
                authCallback={authHandler}
              />
            </div>
          </div>
        </div>
      )}
      <div className="text-right pr-5 text-xs italic">Last Updated: 13-10-2023</div>
      {/* <GetMyPic token={cookies.accessToken}/> */}
    </div>
  );
}
